import { render, staticRenderFns } from "./ContractBtn.vue?vue&type=template&id=5868d5fe&scoped=true"
import script from "./ContractBtn.vue?vue&type=script&lang=js"
export * from "./ContractBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5868d5fe",
  null
  
)

export default component.exports